export enum SignPermissions {
  VIEW_SIGN = "view_sign",
  UPDATE_SIGN = "update_sign",
  APPROVE_REJECT_SIGN = "approve_reject_sign",
  DOWNLOAD_SIGN = "download_sign",
}

export const SignPermissionsText: Record<SignPermissions, string> = {
  [SignPermissions.VIEW_SIGN]: "View Sign",
  [SignPermissions.UPDATE_SIGN]: "Update Sign",
  [SignPermissions.APPROVE_REJECT_SIGN]: "Approve/Reject Sign",
  [SignPermissions.DOWNLOAD_SIGN]: "Download Sign",
};
